import { addDays, differenceInCalendarDays } from 'date-fns';
import { toTenantDate } from '@utils/timeZone';
import { formatTime, shortDate, shortDay } from '@utils/i18n';
import { Schedule, ScheduleContact } from '@root/globalTypes';
import { RelatedDecision } from './types';

export const getShiftDays = (movedTo?: string, movedFrom?: string) =>
  movedTo && movedFrom
    ? differenceInCalendarDays(toTenantDate(movedTo), toTenantDate(movedFrom))
    : 0;

export const shiftIso = (value: string, days: number) =>
  days ? addDays(toTenantDate(value), days).toISOString() : value;

export const dayLabel = (date: Date) => `${shortDay(date)}, ${shortDate(date)}`;

export const dayTimeLabel = (date: Date) => `${dayLabel(date)} · ${formatTime(date)}`;

export const allDecided = (
  list: Schedule[],
  decisionOf: (schedule: Schedule) => RelatedDecision,
  value: RelatedDecision,
) => list.length > 0 && list.every((el) => decisionOf(el) === value);

export const contactName = (contact?: ScheduleContact & { fullName?: string }) =>
  contact?.fullName ||
  contact?.name ||
  [contact?.firstName, contact?.lastName].filter(Boolean).join(' ');
